import * as React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "ColorTheme";
import {
  Navigate,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Layout from "Layout";
import Photos from "pages/the-couple/Photos";
import NavigationBar from "components/NavigationBar";
import OurStory from "pages/the-couple/OurStory";
import Itinerary from "pages/the-wedding/Itinerary";
import WeddingParty from "pages/the-wedding/WeddingParty";
import FAQs from "pages/the-wedding/FAQs";
import Accommodations from "pages/the-venue/Accommodations";
import CampMap from "pages/the-venue/CampMap";
import TheRSVP from "pages/the-rsvp/TheRSVP";
import TheSecretRSVP from "pages/the-secret-rsvp/TheSecretRSVP";
import RSVPSubmitted from "pages/the-rsvp/RSVPSubmitted";
import ErrorPage from "pages/ErrorPage";
import Directions from "pages/the-venue/Directions";
import TheInvitation from "pages/the-invitation/TheInvitation";
import RSVPViewer from "pages/the-backend/rsvp-viewer";
import TheRegistry from "pages/the-registry/TheRegistry";
import Upload from "pages/the-photos/Upload";
import TheStream from "pages/the-stream/TheStream";
import { AuthContextForm, AuthContextProvider } from "components/AuthContext";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: (
      <>
        <NavigationBar />
        <ErrorPage />
      </>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/the-invitation" />,
      },
      {
        path: "the-invitation",
        element: <TheInvitation />,
      },
      {
        path: "the-wedding",
        children: [
          {
            index: true,
            element: <Navigate to="/the-wedding/itinerary" />,
          },
          {
            path: "itinerary",
            element: <Itinerary />,
          },
          {
            path: "our-story",
            element: <OurStory />,
          },
          {
            path: "wedding-party",
            element: <WeddingParty />,
          },
          {
            path: "faqs",
            element: <FAQs />,
          },
        ],
      },
      {
        path: "the-venue",
        children: [
          {
            index: true,
            element: <Navigate to="/the-venue/directions" />,
          },
          {
            path: "directions",
            element: <Directions />,
          },
          {
            path: "accommodations",
            element: <Accommodations />,
          },
          {
            path: "camp-map",
            element: <CampMap />,
          },
        ],
      },
      {
        path: "the-registry",
        element: <TheRegistry />,
      },
      {
        path: "the-rsvp",
        children: [
          {
            index: true,
            element: <TheRSVP />,
          },
          {
            path: "submitted",
            element: <RSVPSubmitted />,
          },
        ],
      },
      {
        path: "the-secret-rsvp",
        children: [
          {
            index: true,
            element: <TheSecretRSVP />,
          },
        ],
      },
      {
        path: "the-backend",
        children: [
          {
            index: true,
            element: <Navigate to="/the-backend/rsvp-viewer" />,
          },
          {
            path: "rsvp-viewer",
            element: <RSVPViewer />,
          },
        ],
      },
      {
        path: "the-photos",
        children: [
          {
            index: true,
            element: <Navigate to="/the-photos/wedding-photos" />,
          },
          {
            path: "wedding-photos",
            element: (
              <Photos bucket_name={"wedding_photos"} title="Wedding Photos" />
            ),
          },
          {
            path: "our-photos",
            element: (
              <AuthContextForm>
                <Photos bucket_name={"couple_photos"} title="Our Photos" />
              </AuthContextForm>
            ),
          },
          {
            path: "our-escape-rooms",
            element: (
              <Photos
                bucket_name={"escape_room_photos"}
                title="Our Escape Rooms"
              />
            ),
          },
          { path: "upload", element: <Upload /> },
        ],
      },
      {
        path: "the-stream",
        element: <TheStream />,
      },
      {
        path: "*",
        element: <ErrorPage />,
      },
    ],
  },
]);

function App() {
  return (
    <>
      <AuthContextProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider router={router} />
        </ThemeProvider>
      </AuthContextProvider>
    </>
  );
}

export default App;
